export default __webpack_public_path__ + "static/media/scrum-simulation-with-lego-agile-game-4-638.e962e112.jpg";